import { fetchCatalogsIfNeeded, getCatalog } from './catalog';
import { fetchBidLimitBalanceIfNeeded } from './bidLimit';
import { fetchCatalogBiddingIfNeeded } from './catalogBiddingInfo';
import { fetchCatalogCuratorsIfNeeded } from './catalogCurators';
import { fetchCatalogDetailsIfNeeded } from './catalogDetail';
import { fetchCatalogFeaturedIfNeeded } from './catalogFeatured';
import { fetchCatalogItemsIfNeeded } from './catalogItems';
import { fetchCoverLotsIfNeeded } from './coverLots';
import { fetchSellerFollowerCountIfNeeded } from './sellerFollowerCount';
import { fetchSellerRatingsByIdIfNeeded } from './sellerRatings';
import { fetchSellersDetailsIfNeeded } from './sellerDetail';
import { fetchSellersIfNeeded } from './seller';
import { fetchTopSellersIfNeeded } from './topRatedSellers';
import { getNotFoundUrl } from '@/utils/urls';
import { push } from 'connected-react-router';

/* ACTION CREATORS */
export const fetchDataForCatalogPage = (catalogId: number) => async (dispatch: Function, getState: Function) => {
    await Promise.all([
        dispatch(fetchCatalogsIfNeeded([catalogId])),
        dispatch(fetchBidLimitBalanceIfNeeded(catalogId)),
        dispatch(fetchCatalogFeaturedIfNeeded(catalogId)),
        dispatch(fetchCatalogBiddingIfNeeded(catalogId)),
        dispatch(fetchCatalogItemsIfNeeded(catalogId)),
        dispatch(fetchCatalogDetailsIfNeeded([catalogId])),
        dispatch(fetchCoverLotsIfNeeded([catalogId])),
        dispatch(fetchCatalogCuratorsIfNeeded(catalogId)),
        dispatch(fetchTopSellersIfNeeded()),
    ]);

    const state = getState();
    const { sellerId } = getCatalog(state, catalogId);

    if (!sellerId) {
        return dispatch(push(getNotFoundUrl()));
    }

    return Promise.all([
        dispatch(fetchSellersIfNeeded([sellerId])),
        dispatch(fetchSellersDetailsIfNeeded([sellerId])),
        dispatch(fetchSellerFollowerCountIfNeeded([sellerId])),
        dispatch(fetchSellerRatingsByIdIfNeeded({ sellerId: sellerId })),
    ]);
};
